import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ZendeskIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M7.46739 5.80138V13.6107H1L7.46739 5.80138Z"
		></path>
		<path
			fill="currentColor"
			d="M7.4677 3C7.4677 4.78458 6.02205 6.23024 4.23746 6.23024C2.45288 6.23024 1.00722 4.78458 1.00722 3H7.4677Z"
		></path>
		<path
			fill="currentColor"
			d="M8.53258 13.6107C8.53258 11.8261 9.97823 10.3804 11.7628 10.3804C13.5474 10.3804 14.9931 11.8261 14.9931 13.6107H8.53258Z"
		></path>
		<path fill="currentColor" d="M8.53258 10.8093V3H15L8.53258 10.8093Z"></path>
	</svg>
))
